import React from "react";
import { useThemeSettings } from "../theme/ThemeSettingsProvider";

function Logo({ variant = "medium" }) {
  const { mode } = useThemeSettings();
  let height = 40;

  if (variant === "small") {
    height = 24;
  }

  if (variant === "large") {
    height = 100;
  }
  return (
    <img
      src={
        mode === "light"
          ? "/images/logo/raven_logo_dark.png"
          : "/images/logo/raven_logo_light.png"
      }
      alt="raven_logo"
      height={height}
      width={"auto"}
    />
  );
}

export default Logo;
